<lib-modal
  data-testid="report-dialog"
  [title]="'testResults.report.title' | translate"
  [subtitle]="subtitleText()"
  [showClose]="true"
  [closeLabel]="'testResults.report.close' | translate"
  [showButtons]="false"
  [visible]="visible()"
  [contentTemplate]="content"
  [footerTemplate]="footer"
  (visibleChange)="visible.set($event)"
></lib-modal>

<ng-template #content>
  <div class="rm-body">
    <div class="rm-options">
      <div class="rm-label">{{ 'testResults.report.sections.art' | translate }}</div>
      <div class="rm-arts" data-group="art">
        @for (a of arts; track a) {
          <button
            type="button"
            class="rm-art"
            [class.rm-art--on]="art() === a"
            [attr.data-testid]="'report-art-' + a"
            [attr.aria-pressed]="art() === a"
            (click)="art.set(a)"
          >
            <span class="rm-art__icon" aria-hidden="true">
              <mat-icon>{{ artIcon[a] }}</mat-icon>
            </span>
            <span>
              <span class="rm-art__title">{{ 'testResults.report.art.' + a + '.title' | translate }}</span>
              &ngsp;
              <span class="rm-art__desc">{{ 'testResults.report.art.' + a + '.desc' | translate }}</span>
            </span>
          </button>
        }
      </div>

      <div class="rm-label">
        {{ 'testResults.report.sections.umfang' | translate }}
        @if (fromView()) {
          <span class="rm-label__tag" data-testid="report-from-view">
            {{ 'testResults.report.fromView' | translate }}
          </span>
        }
      </div>
      <lib-segmented-filter-control
        data-group="umfang"
        variant="radio"
        density="compact"
        [ariaLabel]="'testResults.report.sections.umfang' | translate"
        [items]="[
          { id: 'RELEASE', label: releaseLabel() },
          { id: 'PLAN', label: 'testResults.report.umfang.plan' | translate },
        ]"
        [value]="umfang()"
        (valueChange)="chooseUmfang($event)"
      ></lib-segmented-filter-control>
      @if (umfang() === 'PLAN') {
        <select
          class="rm-select"
          data-testid="report-plan-select"
          [attr.aria-label]="'testResults.report.umfang.planSelectLabel' | translate"
          (change)="choosePlan($any($event.target).value)"
        >
          @for (p of plans(); track p.id) {
            <option [value]="p.id" [selected]="p.id === selectedPlan()?.id">{{ planLabel(p) }}</option>
          }
        </select>
      }

      @if (art() === 'STATUS') {
        <div class="rm-label">{{ 'testResults.report.sections.zeitraum' | translate }}</div>
        <lib-segmented-filter-control
          data-group="zeitraum"
          variant="radio"
          density="compact"
          [ariaLabel]="'testResults.report.sections.zeitraum' | translate"
          [items]="[
            { id: 'SEIT_LETZTEM', label: 'testResults.report.zeitraum.SEIT_LETZTEM' | translate },
            { id: 'SIEBEN_TAGE', label: 'testResults.report.zeitraum.SIEBEN_TAGE' | translate },
            { id: 'SEIT_TESTBEGINN', label: 'testResults.report.zeitraum.SEIT_TESTBEGINN' | translate },
          ]"
          [value]="zeitraum()"
          (valueChange)="chooseZeitraum($event)"
        ></lib-segmented-filter-control>
        @if (stufen().length > 0) {
          <div class="rm-label">{{ 'testResults.report.sections.teststufe' | translate }}</div>
          <select
            class="rm-select"
            data-testid="report-stufe-select"
            [attr.aria-label]="'testResults.report.sections.teststufe' | translate"
            (change)="chooseStufe($any($event.target).value)"
          >
            <option value="" [selected]="!stufe()">{{ 'testResults.toolbar.alleStufen' | translate }}</option>
            @for (s of stufen(); track s.name) {
              <option [value]="s.name" [selected]="s.name === stufe()">{{ s.name }} · {{ s.umgebung }}</option>
            }
          </select>
        }
      }

      @if (art() !== 'TRACEABILITY') {
        <div class="rm-label">{{ 'testResults.report.sections.vergleich' | translate }}</div>
        <button
          type="button"
          class="rm-check"
          data-testid="report-compare"
          disabled
          aria-pressed="false"
          [title]="'testResults.report.vergleich.hint' | translate"
        >
          <span class="rm-check__box" aria-hidden="true"></span>
          <span>
            <span class="rm-check__label">{{ 'testResults.report.vergleich.label' | translate }}</span>
            &ngsp;
            <span class="rm-check__hint">{{ 'testResults.report.vergleich.hint' | translate }}</span>
          </span>
        </button>
      }

      <div class="rm-label">{{ 'testResults.report.sections.format' | translate }}</div>
      <lib-segmented-filter-control
        data-group="format"
        variant="radio"
        density="compact"
        [ariaLabel]="'testResults.report.sections.format' | translate"
        [items]="[
          { id: 'PDF', label: 'testResults.report.format.PDF' | translate },
          { id: 'XLSX', label: 'testResults.report.format.XLSX' | translate },
        ]"
        [value]="format()"
        (valueChange)="chooseFormat($event)"
      ></lib-segmented-filter-control>
      @if (format() === 'XLSX') {
        <div class="rm-sheets">
          @for (sheet of sheets(); track sheet) {
            <span class="rm-sheet">{{ 'testResults.report.sheets.' + sheet | translate }}</span>
          }
        </div>
      }

      <button
        type="button"
        class="rm-check rm-check--save"
        data-testid="report-save-version"
        [class.rm-check--on]="saveActive()"
        [disabled]="!canSaveVersion()"
        [attr.aria-pressed]="saveActive()"
        (click)="toggleSave()"
      >
        <span class="rm-check__box" aria-hidden="true">
          @if (saveActive()) {
            ✓
          }
        </span>
        <span>
          <span class="rm-check__label">{{ 'testResults.report.save.label' | translate }}</span>
          &ngsp;
          <span class="rm-check__hint">{{ 'testResults.report.save.hint' | translate }}</span>
        </span>
      </button>

      @if (confirmation(); as done) {
        <div class="rm-done" role="status">
          <div class="rm-done__title">
            <mat-icon aria-hidden="true">check</mat-icon>
            {{ 'testResults.report.success.title' | translate }}
          </div>
          <code class="rm-done__file">{{ done.filename }}</code>
          @if (done.savedInRefresh !== null) {
            <div class="rm-done__version">
              @if (savedVersion(); as version) {
                {{ 'testResults.report.success.version' | translate: { version: version } }}
              } @else {
                {{ 'testResults.report.success.versionUnknown' | translate }}
              }
            </div>
          }
        </div>
      }
      @if (generateError(); as message) {
        <p class="rm-gen-error" role="alert">{{ message }}</p>
      }

      <div class="rm-label">{{ 'testResults.report.sections.versions' | translate: { release: releaseLabel() } }}</div>
      @let versions = versionsState();
      @if (versions.status === 'error') {
        <div class="rm-versions-state">
          <p class="rm-versions-state__text" role="alert" data-testid="report-versions-error">
            {{ 'testResults.report.errors.versions' | translate }}
          </p>
          <button type="button" class="rm-retry" data-testid="report-versions-retry" (click)="retryVersions()">
            {{ 'testResults.report.retry' | translate }}
          </button>
        </div>
      } @else if (versions.versions.length > 0) {
        <div class="rm-versions">
          @for (v of versions.versions; track v.version) {
            <div class="rm-version" data-testid="report-version-row">
              <span class="rm-version__nr">v{{ v.version }}</span>
              <span class="rm-version__text">
                <span class="rm-version__title">{{ v.titel }}</span>
                <span class="rm-version__meta">
                  {{ v.erzeugtAm | date: 'dd.MM.yyyy' }}
                  @if (v.autorName) {
                    · {{ v.autorName }}
                  }
                  @if (v.teststufe) {
                    · {{ 'testResults.report.doc.status.stage' | translate: { stufe: v.teststufe } }}
                  }
                </span>
              </span>
              <span class="rm-version__format" [attr.data-format]="v.format">{{ v.format }}</span>
              <button
                type="button"
                class="rm-version__download"
                [title]="'testResults.report.versions.download' | translate"
                [attr.aria-label]="'testResults.report.versions.downloadAria' | translate: { titel: v.titel }"
                [disabled]="downloadingVersion() === v.version"
                (click)="downloadVersion(v)"
              >
                <span aria-hidden="true">↓</span>
              </button>
            </div>
          }
        </div>
      } @else if (versions.status === 'loading') {
        <p class="rm-versions-state__text" role="status" data-testid="report-versions-loading">
          {{ 'testResults.report.versions.loading' | translate }}
        </p>
      } @else {
        <p class="rm-versions-state__text" data-testid="report-versions-empty">
          {{ 'testResults.report.versions.empty' | translate }}
        </p>
      }
      @if (versionError(); as message) {
        <p class="rm-gen-error" role="alert" data-testid="report-version-error">{{ message }}</p>
      }
    </div>

    <div class="rm-stage">
      @if (loading()) {
        <p class="rm-loading" role="status">{{ 'testResults.report.loading' | translate }}</p>
      } @else if (plansFailed()) {
        <p class="rm-error" role="alert">{{ 'testResults.report.errors.plans' | translate }}</p>
        <button type="button" class="rm-retry" data-testid="report-plans-retry" (click)="retryPlans()">
          {{ 'testResults.report.retry' | translate }}
        </button>
      } @else if (preview().error; as message) {
        <p class="rm-error" role="alert">{{ message }}</p>
        <button type="button" class="rm-retry" data-testid="report-preview-retry" (click)="retryPreview()">
          {{ 'testResults.report.retry' | translate }}
        </button>
      } @else if (!data() || isEmpty()) {
        <p class="rm-empty">{{ 'testResults.report.empty' | translate }}</p>
      } @else if (data(); as d) {
        <div class="rm-doc" data-testid="report-preview">
          <div class="rm-doc__head">
            <img
              class="rm-doc__logo"
              src="assets/img/TestSolutions_Logo_white.png"
              [alt]="'testResults.report.doc.logoAlt' | translate"
            />
            <div class="rm-doc__head-text">
              <div class="rm-doc__title">{{ 'testResults.report.art.' + d.art + '.title' | translate }}</div>
              <div class="rm-doc__sub">
                {{ scopeLabel() }} · {{ 'testResults.report.stand' | translate: { date: standText(d.stand) } }}
              </div>
            </div>
          </div>

          @if (d.status; as s) {
            <app-report-doc-status [status]="s" [scopeLabel]="scopeLabel()" />
          } @else if (d.abschluss; as a) {
            <app-report-doc-abschluss [abschluss]="a" [scopeLabel]="scopeLabel()" [projectId]="projectId()" />
          } @else if (d.traceability; as rows) {
            <app-report-doc-trace [rows]="rows" />
          }

          <div class="rm-doc__foot">
            <span>{{ 'testResults.report.doc.foot' | translate: { stand: standText(d.stand) } }}</span>
            <span>{{ 'testResults.report.doc.page' | translate }}</span>
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>

<ng-template #footer>
  <div class="rm-actions">
    <button type="button" lib-button variant="secondary" data-testid="report-close" (click)="close()">
      {{ 'testResults.report.close' | translate }}
    </button>
    <button
      type="button"
      lib-button
      variant="primary"
      data-testid="report-generate"
      [disabled]="!canGenerate()"
      (click)="generate()"
    >
      @if (generating()) {
        {{ 'testResults.report.generating' | translate }}
      } @else {
        <span aria-hidden="true">↓</span>
        {{ 'testResults.report.generate.' + format() | translate }}
      }
    </button>
  </div>
</ng-template>
